{
  "manage": {
    "title": "Manage Forms"
  },
  "forms": {
    "confirmation": {
      "thank_you": "Thank you",
      "default_message": "Thank you for submitting the form. Your information has been successfully received.",
      "redirect_message": "You are being redirected to",
      "nexl_branding": "This form was created using Nexl. Explore",
      "learn_more": "to learn more"
    },
    "waitlist": {
      "settings": {
        "description": "Adjust your waitlist settings, including conditions and redirect URL",
        "enable_label": "Enable Waitlist",
        "redirect_url_label": "Redirect URL",
        "redirect_url_placeholder": "Paste URL here"
      },
      "condition": {
        "label": "Condition",
        "add_button": "Add Condition",
        "modal_title": "Condition",
        "modal_caption": "Do the action only when this condition is met.",
        "rollup_field_label": "Rollup Field",
        "select_field": "Select Field",
        "no_rollup_field_option": "No rollup is related to this list",
        "operation_label": "Operation",
        "value_label": "Value",
        "operation_value_label_greater_than_or_equal_to": "is greater than or equal to",
        "operation_value_label_is": "is",
        "rollup_field_tooltip": "Roll-up field is required to use the waitlist feature. You can create one via the Workspace action menu."
      },
      "validation": {
        "redirect_url_invalid": "Please enter a valid URL",
        "redirect_url_required": "Redirect URL is required",
        "field_required": "Please select a field",
        "value_number_required": "Please enter a number",
        "value_integer_required": "Value must be an integer",
        "value_positive_required": "Value must be greater than 0",
        "value_required": "Please enter a value",
        "condition_required": "Please add a condition"
      }
    }
  }
}
